import WIPFeaturesContext from 'context/wip-features/wip-features.context';
import { useI18n } from 'hooks/useI18n';
import { UIOfferHeroSection } from 'interfaces/ui/ui-offer-hero-section';
import { useContext } from 'react';
import Avatar from '../../shared/Avatar';
import {
  StyledHeroCompany,
  StyledHeroCompanyFooter,
  StyledHeroCompanyHeader,
  StyledHeroCompanyInfo,
  StyledHeroCompanyLogo,
  StyledHeroCompanyManagement,
  StyledHeroCompanyPhoto,
  StyledHeroCompanyScout,
  StyledHeroCompanyScoutInfo
} from './HeroCompany.styled';

const HeroCompany = (props: UIOfferHeroSection) => {
  const { t } = useI18n('job-offer');
  const showWIPFeatures = useContext(WIPFeaturesContext);

  return (
    <StyledHeroCompany>
      <StyledHeroCompanyHeader>
        {props.companyLogo && (
          <StyledHeroCompanyLogo
            src={props.companyLogo}
            alt={props.companyName}
          />
        )}

        {showWIPFeatures && (
          <StyledHeroCompanyInfo>
            <a
              href={props.companyUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {props.companyName}
            </a>
            {props.companyArea && <span>{props.companyArea}</span>}
          </StyledHeroCompanyInfo>
        )}
      </StyledHeroCompanyHeader>

      {props.companyPhoto && (
        <StyledHeroCompanyPhoto>
          <img src={props.companyPhoto} alt={props.companyPhotoAlt} />
        </StyledHeroCompanyPhoto>
      )}

      <StyledHeroCompanyFooter>
        {props.companyManagementLogo && (
          <StyledHeroCompanyManagement>
            <span>{t('hero.offerHandledBy')}</span>
            <img
              width={110}
              height={20}
              src={props.companyManagementLogo}
              alt={props.companyManagementLogoAlt}
            />
          </StyledHeroCompanyManagement>
        )}

        {props.companyScout !== '' && (
          <StyledHeroCompanyScout>
            <Avatar
              className="scout-avatar"
              avatarImg={props.companyScoutAvatar}
              avatarAlt={props.companyScout}
            />

            <StyledHeroCompanyScoutInfo>
              <a
                href={`mailto:${props.companyScoutUrl}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {props.companyScout}
              </a>
              <span>{t('hero.scout')}</span>
            </StyledHeroCompanyScoutInfo>
          </StyledHeroCompanyScout>
        )}
      </StyledHeroCompanyFooter>
    </StyledHeroCompany>
  );
};

export default HeroCompany;
